module.exports = __webpack_public_path__ + "static/media/book-tech.fw.ea5f4257.png";